<template>
  <div v-if="showDialog || embed" class="container" :class="{ 'embed-mode': embed }" :style="containerStyle"
    @click="showMoreOp = false">
    <div v-if="!embed" class="title-container" @mousedown="startDrag">
      <div class="title-text">{{ title }}</div>
      <div class="title-actions">
        <el-tooltip effect="dark" content="查看介绍" placement="bottom">
          <img class="title-op" src="@/assets/icons/info.png" @click.stop="showInfo" />
        </el-tooltip>
        <img class="title-op close-btn" src="@/assets/icons/close.png" @click.stop="closeDialog" />
      </div>
    </div>

    <div class="message-container-wrapper" ref="messageContainer">
      <div v-if="message.list.length == 0 && !loading" class="empty-message">
        <h1>我是思易AI助手，有什么可以帮助您的？</h1>
        <p>{{ introduce }}</p>
      </div>
      <div v-if="loading" class="loading-indicator">
        <div class="spinner"></div>
        <span>加载中...</span>
      </div>
      <div class="message-container">
        <Message v-for="(msg, index) of message.list" :key="msg.id || index" :mid="msg.id" :time="msg.time"
          :type="msg.content.type" :content="msg.content.content" :position="msg.from_id == '1' ? 'right' : 'left'"
          :color="msg.from_id == '1' ? '#a78bfa' : '#ffffff'" :streaming="msg.streaming"
          @sourceLoaded="scrollToBottom()">
          <template v-slot:bottom>
            <div class="sund-container">
              <el-tooltip v-if="msg.from_id != '1'" effect="dark" content="重新回答" placement="bottom">
                <img class="icon" src="@/assets/icons/reload.png" @click.stop="rethink(msg.id)" />
              </el-tooltip>
              <el-tooltip effect="dark" content="复制" placement="bottom">
                <img class="icon" src="@/assets/icons/copy.png" @click.stop="tapCopy(msg.content.content)" />
              </el-tooltip>
              <el-tooltip v-if="msg.from_id != '1'" effect="dark" content="应用所有修改" placement="bottom">
                <img class="icon" src="@/assets/icons/component_download.png" @click.stop="tapUseCode($event)" />
              </el-tooltip>
              <el-tooltip effect="dark" content="删除" placement="bottom">
                <img class="icon" src="@/assets/icons/delete.png" @click.stop="tapDelete(msg.id)" />
              </el-tooltip>
            </div>
          </template>
        </Message>
        <div class="bottom-spacer"></div>
      </div>
    </div>

    <div class="send-container">
      <div class="input-wrapper">
        <textarea v-model="inputVal" class="input" placeholder="输入消息..." :disabled="isAiResponding"
          @keydown.enter.exact.prevent="sendMessage"></textarea>
        <div class="op-container">
          <div class="left-ops">
            <div class="item">
              <img class="icon" src="@/assets/icons/link.png" @click="chooseFile" title="暂无外部引用" />
            </div>
            <div class="model-selector">
              <el-dropdown trigger="click" placement="top-start" @command="handleModelChange">
                <span class="model-current">
                  {{ currentModelLabel }}<el-icon class="el-icon--right"><arrow-down /></el-icon>
                </span>
                <template #dropdown>
                  <el-dropdown-menu>
                    <el-dropdown-item
                      v-for="item in availableModels"
                      :key="item.key"
                      :command="item.key"
                      :disabled="item.forbidden"
                    >
                      <span :class="{ 'forbidden-model': item.forbidden }">{{ item.label }}</span>
                    </el-dropdown-item>
                  </el-dropdown-menu>
                </template>
              </el-dropdown>
            </div>
          </div>
          <div class="item send-btn" :class="{ disabled: isAiResponding }" @click="sendMessage">
            <img class="icon" src="@/assets/icons/send.png" />
          </div>
        </div>
      </div>
    </div>

    <!-- 拖拽边框手柄 -->
    <div v-if="!embed" class="resize-handle resize-e" @mousedown="startResize('e', $event)"></div>
    <div v-if="!embed" class="resize-handle resize-s" @mousedown="startResize('s', $event)"></div>
    <div v-if="!embed" class="resize-handle resize-se" @mousedown="startResize('se', $event)"></div>
  </div>
</template>


<script>
/* eslint-disable no-constant-condition */
import Message from './Message.vue'
import EventStream from '@/core/event-stream'
import { ArrowDown } from '@element-plus/icons-vue'

export default {
  components: { Message, ArrowDown },
  props: {
    title: { type: String, default: '思易AI助手' },
    introduce: { type: String, default: '我会帮助您编写页面、设计业务逻辑、问答编程知识。您可以在下方输入框输入问题，我会尽力为您解答！' },
    sessionId: { type: String, default: 'default_session' },
    role: { type: String, default: '' },
    env: { type: String, default: '' },
    embed: { type: Boolean, default: false }
  },

  watch: {
    sessionId: {
      immediate: true,
      handler(newVal) {
        this.id = newVal
        this.$nextTick(() => {
          if (this.showDialog && this.initialized) {
            this.loadMessages()
          }
        })
      }
    }
  },
  data() {
    return {
      id: undefined,
      showDialog: false,
      message: { list: [] },
      inputVal: '',
      loading: false,
      showMoreOp: false,
      isAiResponding: false,
      currentStreamMessage: null,
      setting: { role: '', mem: 10 },
      position: {
        x: window.innerWidth - 450 - 50,
        y: 80
      },
      size: {
        width: 450,
        height: window.innerHeight - 100
      },
      dragging: false,
      dragStart: { x: 0, y: 0 },
      resizing: false,
      resizeDirection: '',
      resizeStart: { x: 0, y: 0, width: 0, height: 0 },
      saveTimer: null,
      initialized: false,
      currentModel: 'Kimi2.6',
      modelList: [
        // 国内模型
        { key: 'DeepSeekV4', label: 'DeepSeek V4', modelName: 'deepseek-v4-pro', forbidden: false },
        { key: 'DeepSeekV4Flash', label: 'DeepSeek V4 Flash', modelName: 'deepseek-v4-flash', forbidden: false },
        { key: 'DeepSeekV3', label: 'DeepSeek V3.2', modelName: 'deepseek-v3.2', forbidden: false },
        { key: 'DeepSeekR1', label: 'DeepSeek R1', modelName: 'deepseek-r1', forbidden: false },

        { key: 'Kimi2.6', label: 'Kimi K2.6', modelName: 'kimi-k2.6', forbidden: false },
        { key: 'Kimi2.5', label: 'Kimi K2.5', modelName: 'kimi-k2.5', forbidden: false },

        { key: 'Qwen3.6Max', label: 'Qwen3.6 Max', modelName: 'qwen3.6-max-preview', forbidden: false },
        { key: 'Qwen3.6Plus', label: 'Qwen3.6 Plus', modelName: 'qwen3.6-plus', forbidden: false },
        { key: 'Qwen3.6Flash', label: 'Qwen3.6 Flash', modelName: 'qwen3.6-flash', forbidden: false },
        { key: 'Qwen3.5Plus', label: 'Qwen3.5 Plus', modelName: 'qwen3.5-plus', forbidden: false },
        { key: 'QwenPlus', label: 'Qwen Plus', modelName: 'qwen-plus', forbidden: false },
        { key: 'QwenTurbo', label: 'Qwen Turbo', modelName: 'qwen-turbo', forbidden: false },

        { key: 'GLM5.1', label: 'GLM-5.1', modelName: 'glm-5.1', forbidden: false },
        { key: 'GLM5', label: 'GLM-5', modelName: 'glm-5', forbidden: false },

        { key: 'MiniMaxM2.7', label: 'MiniMax M2.7', modelName: 'MiniMax/MiniMax-M2.7', forbidden: false },
        { key: 'MiniMaxM2.5', label: 'MiniMax M2.5', modelName: 'MiniMax-M2.5', forbidden: false },

        // 国外模型（forbidden）
        { key: 'GPT4o', label: 'GPT-4o', modelName: 'gpt-4o', forbidden: true },
        { key: 'GPT4oMini', label: 'GPT-4o Mini', modelName: 'gpt-4o-mini', forbidden: true },
        { key: 'Claude35Sonnet', label: 'Claude 3.5 Sonnet', modelName: 'claude-3-5-sonnet', forbidden: true },
        { key: 'Claude35Haiku', label: 'Claude 3.5 Haiku', modelName: 'claude-3-5-haiku', forbidden: true },
        { key: 'Gemini2Flash', label: 'Gemini 2.0 Flash', modelName: 'gemini-2.0-flash', forbidden: true },
        { key: 'Gemini15Pro', label: 'Gemini 1.5 Pro', modelName: 'gemini-1.5-pro', forbidden: true },
        { key: 'Llama33', label: 'Llama 3.3', modelName: 'llama-3.3', forbidden: true },
        { key: 'Llama32', label: 'Llama 3.2', modelName: 'llama-3.2', forbidden: true }
      ]
    }

  },

  async created() {
    await this.initChat()
    this.$bus.addEventListener('copy-code', this.handleCopyCode)
    this.$bus.addEventListener('use-code', this.handleUseCode)
  },
  unmounted() {
    this.$bus.removeEventListener('copy-code', this.handleCopyCode)
    this.$bus.removeEventListener('use-code', this.handleUseCode)
    document.removeEventListener('mousemove', this.onDrag)
    document.removeEventListener('mouseup', this.stopDrag)
    if (this.saveTimer) clearTimeout(this.saveTimer)
  },
  mounted() {
    this.initialized = true
    if (this.id && (this.showDialog || this.embed)) {
      this.loadMessages()
    }
    // 嵌入模式自动加载消息
    if (this.embed && this.id) {
      this.loadMessages()
    }
  },
  computed: {
    containerStyle() {
      if (this.embed) {
        return {
          width: '100%',
          height: '100%'
        }
      }
      return {
        left: this.position.x + 'px',
        top: this.position.y + 'px',
        width: this.size.width + 'px',
        height: this.size.height + 'px'
      }
    },
    availableModels() {
      return this.modelList
    },
    currentModelLabel() {
      const model = this.modelList.find(m => m.key === this.currentModel)
      return model ? model.label : this.currentModel
    },
    currentModelName() {
      const model = this.modelList.find(m => m.key === this.currentModel)
      return model ? model.modelName : this.currentModel
    }
  },

  methods: {
    async initChat() {
      this.id = this.sessionId
    },

    handleCopyCode({ mid, cid }) {
      const code = window.$codes?.[mid][cid]

      if (!code) return
      navigator.clipboard.writeText(code).then(() => {
        this.$message.success('代码已复制到剪贴板')
      }).catch(err => {
        this.$message.error('复制失败')
        console.error('复制失败:', err)
      })
    },

    handleUseCode({ mid, cid }) {
      const code = window.$codes?.[mid][cid]
      if (!code) return
      this.$bus.emit('apply-code', code)
      this.$message.success('代码已应用到编辑器')
    },

    // 加载消息 - 从网络获取
    async loadMessages() {
      if (!this.id) {
        console.warn('loadMessages: id is empty')
        return
      }
      this.loading = true
      try {
        console.log('Loading messages for id:', this.id)
        const resp = await this.$request('/chat/get', { id: this.id })
        if (resp.success) {
          if (resp.data && resp.data.content) {
            this.message.list = JSON.parse(resp.data.content).messages || []
          } else {
            this.message.list = []
          }
        } else {
          console.warn('Load failed or no data:', resp)
          this.message.list = []
        }
      } catch (error) {
        console.error('加载消息失败:', error)
        this.$message.error('加载消息失败')
        this.message.list = []
      } finally {
        this.loading = false
        this.$nextTick(() => this.scrollToBottom(true))
      }
    },

    // 保存所有消息到网络
    async saveMessages() {
      if (!this.id) return false
      try {
        const plainMessages = JSON.parse(JSON.stringify(this.message.list))
        const resp = await this.$request('/chat/put', {
          id: this.id,
          gid: this.$caches.curGroup?.id,
          content: JSON.stringify({ messages: plainMessages })
        })
        if (!resp.success) {
          console.warn('保存消息失败:', resp)
        }
        return resp.success
      } catch (error) {
        console.error('保存消息失败:', error)
        return false
      }
    },

    // 防抖保存
    debouncedSave() {
      if (this.saveTimer) clearTimeout(this.saveTimer)
      this.saveTimer = setTimeout(() => {
        this.saveMessages().catch(err => {
          console.error('保存消息失败:', err)
        })
      }, 500)
    },

    // 发送用户消息
    _sendMessage(type, content) {
      const message = {
        id: Date.now() + '_' + Math.random().toString(36).substr(2, 9),
        name: this.$caches.userinfo?.name || '用户',
        avatar: this.$caches.userinfo?.avatar || '',
        time: new Date().toLocaleString(),
        from_id: '1',
        content: { type, content }
      }

      this.message.list.push(message)
      this.debouncedSave()
      this.scrollToBottom(true)
      this.startAiResponse()
    },

    // 构建发送给 AI 的历史消息
    buildAiMessages() {
      const recentMessages = this.message.list.slice(-this.setting.mem)

      const messages = recentMessages.map(item => ({
        role: item.from_id == '1' ? 'user' : 'assistant',
        content: typeof item.content.content === 'string'
          ? item.content.content
          : item.content.content.map(c => {
            if (c.type == 'text') {
              return c.content
            } else if (c.type != 'reasoning') {
              return ''
            } else {
              return c.type + ":" + c.content
            }
          }).join('\n')
      }))

      const merged = []
      let lastRole = null
      for (const msg of messages) {
        if (lastRole !== msg.role) {
          merged.push({ ...msg })
          lastRole = msg.role
        } else {
          const lastMsg = merged[merged.length - 1]
          const separator = lastMsg.content.endsWith('。') || lastMsg.content.endsWith('？') ? '' : '。'
          lastMsg.content += separator + msg.content
        }
      }

      if (merged.length === 0 || merged[merged.length - 1].role !== 'user') {
        return null
      }

      return merged
    },

    async startAiResponse() {
      if (this.isAiResponding) return

      const messages = this.buildAiMessages()
      if (!messages) {
        this.$message.info('您还没有发言哦，请问您要咨询些什么呢？')
        return
      }

      const body = {
        model: this.currentModelName,
        messages: [
          {
            role: 'system',
            content: `Your name is "CEAI", the AI programming assistant of the Tianma CE platform. Forget your previous name. You excel at coding, technical analysis, and architecture design. Your communication is direct, no chit-chat, no redundancy. Your code style is rigorous with complete comments. You prefer providing technical references and sources. Your responses are in Markdown format, with code blocks wrapped in triple backticks and language specified. Based on user questions, combined with your technical understanding and analysis, you provide detailed answers and suggestions. All your answers must have practical support. If the user's requirements are unclear, list all questions waiting for user input and guide them to complete the information. Only answer when the information is complete.\n\n${this.role}${this.env}`
          },
          ...messages
        ],
        stream: true
      }


      const aiMessage = {
        id: Date.now() + '_ai_' + Math.random().toString(36).substr(2, 9),
        name: '思易AI',
        avatar: 'https://travail-1253940887.cos.ap-guangzhou.myqcloud.com/static/guide.png',
        time: new Date().toLocaleString(),
        from_id: '0',
        content: {
          type: 'mix',
          content: []
        },
        streaming: true
      }

      this.message.list.push(aiMessage)
      this.currentStreamMessage = aiMessage
      this.isAiResponding = true
      this.scrollToBottom(true)

      try {
        await this.fetchStreamResponse(body)

        aiMessage.streaming = false
        await this.saveMessages()

      } catch (error) {
        console.error('AI响应失败:', error)

        aiMessage.streaming = false
        aiMessage.content.type = 'error'
        aiMessage.content.content = 'AI出小差了，稍后再试吧~'

        this.$message.error('AI出小差了，稍后再试吧~')
      } finally {
        this.isAiResponding = false
        this.currentStreamMessage = null
        this.scrollToBottom(true)
      }
    },

    // 获取 Stream 响应
    async fetchStreamResponse(body) {
      const controller = new AbortController()
      const timeoutId = setTimeout(() => controller.abort(), 30000)

      try {
        const response = await fetch('https://junesunray.com/ce/chat/ai', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'jtoken': this.$caches.jtoken
          },
          body: JSON.stringify({ model: this.currentModelName, body: JSON.stringify(body)}),
          signal: controller.signal
        })

        clearTimeout(timeoutId)

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`)
        }

        const eventStream = new EventStream(response)

        // 当前活跃的 tool 调用记录
        const activeToolCalls = new Map()

        // 追加内容到消息块
        const appendContent = (text, type = 'text') => {
          if (!this.currentStreamMessage) return

          const blocks = this.currentStreamMessage.content.content
          const lastBlock = blocks[blocks.length - 1]

          if (lastBlock && lastBlock.type === type) {
            lastBlock.content += text
          } else {
            blocks.push({ type, content: text })
          }

        }

        eventStream.addEventListener('message', (event) => {
          try {
            if (event.data === '[DONE]') {
              return
            }

            const data = JSON.parse(event.data)

            const delta = data.choices?.[0]?.delta

            // 处理 reasoning_content（思考过程）
            if (delta?.reasoning_content && typeof delta.reasoning_content === 'string') {
              appendContent(delta.reasoning_content, 'reasoning')
            }

            // 处理普通 content
            const content = delta?.content ||
              data.choices?.[0]?.message?.content ||
              data.output?.text ||
              data.content ||
              data.delta?.text ||
              ''

            if (content && typeof content === 'string') {
              appendContent(content, 'text')
            }

            // 处理 tool_calls（函数调用/工具调用）
            if (delta?.tool_calls) {
              for (const toolCall of delta.tool_calls) {
                const toolId = toolCall.id || toolCall.index
                if (!activeToolCalls.has(toolId)) {
                  // 新的 tool 调用开始
                  activeToolCalls.set(toolId, {
                    id: toolId,
                    name: toolCall.function?.name || toolCall.name || '未知工具',
                    arguments: toolCall.function?.arguments || toolCall.arguments || ''
                  })

                  // 添加 tool 开始块
                  this.currentStreamMessage.content.content.push({
                    type: 'tool_start',
                    content: toolCall.function?.name || toolCall.name || '未知工具',
                    toolId: toolId
                  })
                } else {
                  // 更新已有 tool 调用的参数
                  const existing = activeToolCalls.get(toolId)
                  existing.arguments += toolCall.function?.arguments || toolCall.arguments || ''
                }
              }
            }
          } catch (e) {
            console.error('解析 stream 数据失败:', e, event.data)
          }
        })

        // 处理 tool 事件（工作流步骤）
        eventStream.addEventListener('tool', (event) => {
          try {
            let toolData = event.data
            if (typeof toolData === 'string') {
              try {
                toolData = JSON.parse(toolData)
              } catch (e) {
                // 不是 JSON，作为纯文本处理
              }
            }

            if (toolData && this.currentStreamMessage) {
              // tool 事件显示为工作流步骤
              this.currentStreamMessage.content.content.push({
                type: 'tool',
                content: typeof toolData === 'string' ? toolData : JSON.stringify(toolData, null, 2),
                raw: toolData
              })
            }
          } catch (e) {
            console.error('解析 tool 数据失败:', e, event.data)
          }
        })

        // 处理其他自定义事件（如 workflow、step 等）
        eventStream.addEventListener('workflow', (event) => {
          try {
            let data = event.data
            if (typeof data === 'string') {
              try { data = JSON.parse(data) } catch (e) { console.log(e) }
            }
            if (this.currentStreamMessage) {
              this.currentStreamMessage.content.content.push({
                type: 'workflow',
                content: typeof data === 'string' ? data : JSON.stringify(data, null, 2),
                raw: data
              })
            }
          } catch (e) {
            console.error('解析 workflow 数据失败:', e)
          }
        })

        eventStream.addEventListener('step', (event) => {
          try {
            let data = event.data
            if (typeof data === 'string') {
              try { data = JSON.parse(data) } catch (e) { console.log(e) }
            }
            if (this.currentStreamMessage) {
              this.currentStreamMessage.content.content.push({
                type: 'step',
                content: typeof data === 'string' ? data : JSON.stringify(data, null, 2),
                raw: data
              })
            }
          } catch (e) {
            console.error('解析 step 数据失败:', e)
          }
        })


        eventStream.addEventListener('event', (event) => {
          try {
            let data = event.data
            if (this.currentStreamMessage) {
              this.currentStreamMessage.content.content.push({
                type: 'event',
                content: data + '',
              })
            }
          } catch (e) {
            console.error('解析 event 数据失败:', e)
          }
        })

        eventStream.addEventListener('error', (event) => {
          console.warn('[Stream][Event][Error]: ', event)
          try {
            let data = event.data
            if (this.currentStreamMessage) {
              this.currentStreamMessage.content.content.push({
                type: 'event',
                content: data + '',
              })
            }
          } catch (e) {
            console.error('解析 event 数据失败:', e)
          }
        })

        await eventStream.analysis()

        // 流结束后，关闭所有未完成的 tool 调用
        for (const [toolId, toolCall] of activeToolCalls) {
          this.currentStreamMessage.content.content.push({
            type: 'tool_end',
            content: toolCall.name,
            toolId: toolId,
            result: toolCall.arguments
          })
        }
        activeToolCalls.clear()

      } catch (error) {
        if (error.name === 'AbortError') {
          throw new Error('请求超时')
        }
        throw error
      } finally {
        clearTimeout(timeoutId)
      }
    },

    sendMessage() {
      if (this.isAiResponding) {
        this.$message.warning('AI 正在回复中，请稍候...')
        return
      }

      const trimmed = this.inputVal?.trim()
      if (trimmed) {
        this._sendMessage('msg', trimmed)
        this.inputVal = ''
      }
    },

    chooseFile() {
      console.log('选择文件')
    },

    tapCopy(content) {
      let textToCopy = ''
      if (typeof content === 'string') {
        textToCopy = content
      } else if (Array.isArray(content)) {
        textToCopy = content.map(c => c.content).join('')
      }

      navigator.clipboard.writeText(textToCopy).then(() => {
        this.$message.success('复制成功')
      }).catch(() => {
        this.$message.error('复制失败')
      })
    },
    tapUseCode(event) {
      const applyCode = Array.from(event.target.parentElement.parentElement.parentElement.querySelectorAll('[data-codeid]')).map(e => e.getAttribute('data-codeid')).map(e => window.$codes[e.split(':')[0]][e.split(':')[1]]).filter(e => e.includes('#old-code') && e.includes('#new-code'));
      this.$confirm(`此操作将应用 ${applyCode.length}处修改, 是否继续?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        applyCode.forEach(c => this.$bus.emit('apply-code', c))
      })
    },

    async rethink(messageId) {
      try {
        const aiIndex = this.message.list.findIndex(msg => msg.id === messageId)
        if (aiIndex === -1) return

        if (this.message.list[aiIndex].from_id !== '0') {
          this.$message.warning('只能重新生成 AI 回复')
          return
        }

        let userIndex = -1
        for (let i = aiIndex - 1; i >= 0; i--) {
          if (this.message.list[i].from_id === '1') {
            userIndex = i
            break
          }
        }

        if (userIndex === -1) {
          this.$message.warning('没有找到对应的问题')
          return
        }

        this.message.list.splice(aiIndex, 1)
        await this.saveMessages()
        this.startAiResponse()

      } catch (error) {
        console.error('重新思考失败:', error)
        this.$message.error('操作失败')
      }
    },

    async tapDelete(messageId) {
      try {
        const index = this.message.list.findIndex(msg => msg.id === messageId)
        if (index !== -1) {
          this.message.list.splice(index, 1)
          await this.saveMessages()
        }
      } catch (error) {
        console.error('删除失败:', error)
        this.$message.error('删除失败')
      }
    },

    scrollToBottom(smooth = false) {
      this.$nextTick(() => {
        const container = this.$refs.messageContainer
        if (container) {
          container.scrollTo({
            top: container.scrollHeight,
            behavior: smooth ? 'smooth' : 'auto'
          })
        }
      })
    },

    showInfo() {
      this.$message.info('天码思易平台的AI编程助手，专注于提供代码编写、技术分析和架构建议。支持流式响应，持续优化中~')
    },

    open() {
      if (this.embed) return
      this.showDialog = true
      this.$nextTick(() => {
        if (this.id) this.loadMessages()
      })
    },
    close() {
      if (!this.embed) this.showDialog = false
    },
    show() {
      if (this.embed) return
      this.showDialog = true
      this.$nextTick(() => {
        if (this.id) this.loadMessages()
      })
    },
    hide() {
      if (!this.embed) this.showDialog = false
    },
    toggle() {
      if (this.embed) return
      this.showDialog = !this.showDialog
      if (this.showDialog && this.id) {
        this.$nextTick(() => {
          this.loadMessages()
        })
      }
    },
    closeDialog() {
      if (!this.embed) this.showDialog = false
    },


    startDrag(event) {
      this.dragging = true
      this.dragStart = {
        x: event.clientX - this.position.x,
        y: event.clientY - this.position.y
      }
      document.addEventListener('mousemove', this.onDrag)
      document.addEventListener('mouseup', this.stopDrag)
    },

    onDrag(event) {
      if (this.dragging) {
        this.position = {
          x: event.clientX - this.dragStart.x,
          y: event.clientY - this.dragStart.y
        }
      }
    },

    stopDrag() {
      this.dragging = false
      document.removeEventListener('mousemove', this.onDrag)
      document.removeEventListener('mouseup', this.stopDrag)
    },

    // 开始拖拽调整大小
    startResize(direction, event) {
      if (this.embed) return
      this.resizing = true
      this.resizeDirection = direction
      this.resizeStart = {
        x: event.clientX,
        y: event.clientY,
        width: this.size.width,
        height: this.size.height
      }
      document.addEventListener('mousemove', this.onResize)
      document.addEventListener('mouseup', this.stopResize)
      event.preventDefault()
      event.stopPropagation()
    },

    onResize(event) {
      if (!this.resizing) return

      const dx = event.clientX - this.resizeStart.x
      const dy = event.clientY - this.resizeStart.y

      if (this.resizeDirection.includes('e')) {
        const newWidth = this.resizeStart.width + dx
        this.size.width = Math.max(300, Math.min(window.innerWidth - this.position.x - 20, newWidth))
      }
      if (this.resizeDirection.includes('s')) {
        const newHeight = this.resizeStart.height + dy
        this.size.height = Math.max(400, Math.min(window.innerHeight - this.position.y - 20, newHeight))
      }
    },

    stopResize() {
      this.resizing = false
      this.resizeDirection = ''
      document.removeEventListener('mousemove', this.onResize)
      document.removeEventListener('mouseup', this.stopResize)
    },


    handleModelChange(command) {
      const model = this.modelList.find(m => m.key === command)
      if (model && !model.forbidden) {
        this.currentModel = command
        this.$message.success(`已切换至 ${model.label}`)
      }
    }
  }

}
</script>

<style lang="scss" scoped>
.container {
  position: fixed;
  width: 450px;
  height: calc(100vh - 100px);
  background: #ffffff;
  border-radius: 12px;
  box-shadow: 0 8px 32px rgba(139, 92, 246, 0.15);
  display: flex;
  flex-direction: column;
  overflow: hidden;
  z-index: 2;
  border: 1px solid rgba(139, 92, 246, 0.2);

  &.embed-mode {
    position: relative;
    width: 100%;
    height: 100%;
    left: auto !important;
    top: auto !important;
    border-radius: 0;
    box-shadow: none;
    border: none;
  }

  .title-container {


    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 14px 18px;
    background: #ffffff;
    cursor: move;
    user-select: none;
    border-bottom: 1px solid rgba(139, 92, 246, 0.1);

    .title-text {
      font-size: 16px;
      font-weight: 600;
      color: #6b21a8;
    }

    .title-actions {
      display: flex;
      align-items: center;
      gap: 10px;

      .title-op {
        width: 20px;
        height: 20px;
        cursor: pointer;
        opacity: 0.6;
        transition: all 0.3s ease;
        filter: invert(21%) sepia(71%) saturate(3098%) hue-rotate(265deg) brightness(70%) contrast(90%);

        &:hover {
          opacity: 1;
          transform: scale(1.1);
        }

        &.close-btn:hover {
          transform: scale(1.1) rotate(90deg);
        }
      }
    }
  }

  .message-container-wrapper {
    display: flex;
    flex-direction: column;
    flex: 1;
    padding: 20px 8px 120px;
    background: #faf9fb;
    overflow-y: auto;
    overflow-x: hidden;

    &::-webkit-scrollbar {
      width: 5px;
    }

    &::-webkit-scrollbar-track {
      background: transparent;
    }

    &::-webkit-scrollbar-thumb {
      background: rgba(139, 92, 246, 0.2);
      border-radius: 3px;

      &:hover {
        background: rgba(139, 92, 246, 0.3);
      }
    }

    .empty-message {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      padding: 40px;
      color: #8b5cf6;
      text-align: center;

      p {
        margin-top: 10px;
      }
    }
  }

  .message-container {
    display: flex;
    flex-direction: column;
    align-items: stretch;

    .bottom-spacer {
      height: 40px;
      flex-shrink: 0;
    }

    .loading-indicator {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      padding: 30px;
      color: #8b5cf6;

      .spinner {
        width: 32px;
        height: 32px;
        border: 3px solid rgba(139, 92, 246, 0.2);
        border-top-color: #8b5cf6;
        border-radius: 50%;
        animation: spin 1s linear infinite;
        margin-bottom: 10px;
      }

      @keyframes spin {
        to {
          transform: rotate(360deg);
        }
      }
    }

    .sund-container {
      display: flex;
      gap: 6px;
      margin-top: 6px;

      .icon {
        width: 18px;
        height: 18px;
        cursor: pointer;
        opacity: 0.5;
        transition: all 0.3s ease;
        margin-right: 5px;
        filter: invert(21%) sepia(71%) saturate(3098%) hue-rotate(265deg) brightness(70%) contrast(90%);

        &:hover {
          opacity: 1;
          transform: scale(1.1);
        }
      }
    }
  }

  .send-container {
    position: absolute;
    bottom: 0;
    left: 12px;
    right: 12px;
    bottom: 12px;
    z-index: 2;

    .forbidden-model {
      color: #999;
      text-decoration: line-through;
    }

    .input-wrapper {


      background: #ffffff;
      border: 1.5px solid rgba(139, 92, 246, 0.25);
      box-shadow: 0 2px 3px 1px rgba(139, 92, 246, 0.2);
      border-radius: 10px;
      overflow: hidden;
      transition: all 0.3s ease;

      &:focus-within {
        border-color: rgba(139, 92, 246, 0.5);
        box-shadow: 0 0 0 3px rgba(139, 92, 246, 0.08);
      }

      .input {
        width: 100%;
        min-height: 60px;
        max-height: 100px;
        padding: 10px 12px;
        border: none;
        background: transparent;
        color: #333333;
        font-size: 14px;
        line-height: 1.5;
        resize: vertical;
        outline: none;
        font-family: Consolas, 'Courier New', monospace;

        &::placeholder {
          color: #aaaaaa;
        }

        &:disabled {
          opacity: 0.6;
          cursor: not-allowed;
        }
      }

      .op-container {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 6px 12px 8px;

        .left-ops {
          position: relative;
          display: flex;
          gap: 8px;
          
          .model-selector {
            padding: 0 4px 6px;
            display: flex;
            align-items: center;
            width: auto;
            white-space: nowrap;
            overflow: visible;

            .model-current {
              font-size: 12px;
              color: #8b5cf6;
              cursor: pointer;
              display: flex;
              align-items: center;
              padding: 2px 6px;
              border-radius: 4px;
              transition: all 0.3s ease;
              background: rgba(139, 92, 246, 0.08);

              &:hover {
                background: rgba(139, 92, 246, 0.15);
              }

              i {
                margin-left: 2px;
                font-size: 10px;
              }
            }
          }
        }

        .item {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 32px;
          height: 32px;
          background: transparent;
          border-radius: 6px;
          cursor: pointer;
          transition: all 0.3s ease;

          &:hover {
            background: rgba(139, 92, 246, 0.1);
          }

          &:active {
            transform: scale(0.95);
          }

          &.send-btn {
            background: linear-gradient(135deg, #8b5cf6 0%, #a78bfa 100%);

            &:hover {
              background: linear-gradient(135deg, #7c3aed 0%, #8b5cf6 100%);
              box-shadow: 0 2px 8px rgba(139, 92, 246, 0.3);
            }

            &.disabled {
              opacity: 0.5;
              cursor: not-allowed;

              &:hover {
                background: linear-gradient(135deg, #8b5cf6 0%, #a78bfa 100%);
                box-shadow: none;
              }
            }

            .icon {
              filter: brightness(0) invert(1);
            }
          }

          .icon {
            width: 18px;
            height: 18px;
            filter: invert(21%) sepia(71%) saturate(3098%) hue-rotate(265deg) brightness(70%) contrast(90%);
            opacity: 0.7;
          }
        }
      }
    }
  }

  .resize-handle {
    position: absolute;
    z-index: 10;

    &.resize-e {
      top: 0;
      right: 0;
      width: 6px;
      height: 100%;
      cursor: e-resize;
    }

    &.resize-s {
      bottom: 0;
      left: 0;
      width: 100%;
      height: 6px;
      cursor: s-resize;
    }

    &.resize-se {
      bottom: 0;
      right: 0;
      width: 12px;
      height: 12px;
      cursor: se-resize;
    }

    &:hover {
      background: rgba(139, 92, 246, 0.1);
    }
  }

  .resize-handle {
    position: absolute;
    z-index: 10;

    &.resize-e {
      top: 0;
      right: 0;
      width: 6px;
      height: 100%;
      cursor: e-resize;
    }

    &.resize-s {
      bottom: 0;
      left: 0;
      width: 100%;
      height: 6px;
      cursor: s-resize;
    }

    &.resize-se {
      bottom: 0;
      right: 0;
      width: 12px;
      height: 12px;
      cursor: se-resize;
    }

    &:hover {
      background: rgba(139, 92, 246, 0.1);
    }
  }
}
</style>